// extracted by mini-css-extract-plugin
export default {"Qr":"QrCode_Qr__wSdTz"};